import { render, staticRenderFns } from "./ProjectInfoEditModal.vue?vue&type=template&id=22f90be8&scoped=true&"
import script from "./ProjectInfoEditModal.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoEditModal.vue?vue&type=style&index=0&id=22f90be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f90be8",
  null
  
)

export default component.exports